import { isCreditCard } from 'validator';

import { validateForUI } from 'common/helpers/jsonValidator';

const creditCardSchema = {
  type: 'object',
  properties: {
    cardNumber: { type: 'string' },
    expiryMo: { type: 'integer', minimum: 1, maximum: 12 },
    expiryYr: { type: 'integer', minimum: 2016 },
    cvv2: { type: 'string', maxLength: 4 },
    isDefault: { type: 'boolean' },
    cardHolderName: { type: 'string' }
  },
  required: ['cardNumber', 'expiryMo', 'expiryYr', 'cvv2', 'cardHolderName'],
  additionalProperties: false
};

export const validateAdd = (creditCard) => {
  const errors = validateForUI(
    creditCardSchema,
    creditCard,
    customValidate(creditCard)
  );
  return errors;
};

export const validateEdit = (creditCard) => {
  const errors = validateForUI(
    creditCardSchema,
    creditCard,
    customValidate(creditCard)
  );
  return errors;
};

const customValidate = (creditCard) => {
  const errorArray = [];
  if (creditCard.cardNumber && !isCreditCard(creditCard.cardNumber)) {
    errorArray.push({
      field: 'cardNumber',
      message: 'Invalid credit card number'
    });
  }

  // validate exiry number is in the future
  if (
    creditCard.expiryYr < new Date().getFullYear() ||
    (creditCard.expiryYr === new Date().getFullYear() &&
      creditCard.expiryMo < new Date().getMonth() + 1)
  ) {
    errorArray.push({ field: 'expiryMo', message: 'Invalid expiry date' });
    errorArray.push({ field: 'expiryYr', message: 'Invalid expiry date' });
  }

  return errorArray;
};
